import React from 'react';
import Image from 'next/image';
import linkIcon from '@/images/link-icon.svg';

import { trackWithFingerprint } from '../../utils/trackWithFingerprint';

import 'react-tooltip/dist/react-tooltip.css';
import { ReactTooltip } from './styles';

export function LinkIcon() {
  const onKeyDown = () => ({});

  return (
    <button
      id="link-icon-container"
      data-testid="link-icon-container"
      className="h-9 w-10 cursor-pointer rounded-full bg-[#4FA4AE] pl-0.5 pt-1 hover:bg-[#035C67]"
      onClick={() => {
        navigator.clipboard.writeText(window.location.href);
        trackWithFingerprint('CTA Clicked', {
          blog_share_type: 'Share Link',
          module: 'blog_share_icon'
        });
      }}
      onKeyDown={onKeyDown}
    >
      <Image
        src={linkIcon}
        className="ml-4"
        alt="Link Icon"
        height={30}
        width={30}
      />
      <ReactTooltip
        anchorSelect="#link-icon-container"
        content="Link copied!"
        place="top"
        openOnClick={true}
      />
    </button>
  );
}
